import moment from 'moment';
function mapFullName(driver) {
    const firstName = driver.first_name || '';
    const lastName = driver.last_name || '';
    const fullName = `${firstName} ${lastName}`.trim();
    return Object.assign(Object.assign({}, driver), { fullName });
}
function mapPlatformLabel(driver) {
    // map platform label
    let platformLabel;
    if (driver.client_platform) {
        if (driver.client_version) {
            platformLabel = `${driver.client_platform} v${driver.client_version}`;
        }
        else {
            platformLabel = driver.client_platform;
        }
    }
    else {
        platformLabel = 'Unknown';
    }
    return Object.assign(Object.assign({}, driver), { platformLabel });
}
function mapEquipmentClass(driver) {
    let equipmentClassLabel;
    // map equipment class
    if (driver.equipment_class) {
        equipmentClassLabel = driver.equipment_class.label;
    }
    else {
        equipmentClassLabel = 'Unknown';
    }
    return Object.assign(Object.assign({}, driver), { equipmentClassLabel });
}
function mapJobCount(driver) {
    const pendingCount = 0;
    const jobCount = (driver.jobs || []).length;
    return Object.assign(Object.assign({}, driver), { pendingCount,
        jobCount });
}
function mapLastSeen(driver) {
    const lastSeen = moment(driver.last_check_in).fromNow();
    return Object.assign(Object.assign({}, driver), { lastSeen });
}
const mapDrivers = (drivers) => {
    return drivers
        .map(mapFullName)
        .map(mapEquipmentClass)
        .map(mapJobCount)
        .map(mapPlatformLabel)
        .map(mapLastSeen);
};
export default mapDrivers;
